// extracted by mini-css-extract-plugin
export default {"host":"FormQuery_host__k1iDc","published":"FormQuery_published__8AE72"};